import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useSidebarState } from "./SidebarStateContext";
import { useLocation } from "react-router-dom";

interface SidebarContextType {
  isOpen: boolean;
  mobileMenuOpen: boolean;
  toggleSidebar: () => void;
  openSidebar: () => void;
  closeSidebar: () => void;
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openMobileNav: () => void;
  closeMobileNav: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  const openSidebar = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeSidebar = useCallback(() => {
    setIsOpen(false);
  }, []);

  const openMobileNav = useCallback(() => {
    setIsOpen(true);
    setMobileMenuOpen(true);
  }, []);

  const closeMobileNav = useCallback(() => {
    setIsOpen(false);
    setMobileMenuOpen(false);
  }, []);

  const { handleClick } = useSidebarState();

  useEffect(() => {
    const handleStorageChange = () => {
      const emailData = localStorage.getItem("email_verify");
      const phoneData = localStorage.getItem("phone_verify");
      if (location?.pathname?.includes("productbank")) {
        handleClick("Product Bank");
      } else {
        if (emailData === "false" || phoneData === "false") {
          // setOption("Account");
        } else if (!emailData && !phoneData) {
          // setOption("Analytics");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    handleStorageChange();

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [handleClick, location?.pathname]);

  return (
    <SidebarContext.Provider
      value={{
        isOpen,
        mobileMenuOpen,
        toggleSidebar,
        openSidebar,
        closeSidebar,
        setMobileMenuOpen,
        openMobileNav,
        closeMobileNav,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
